// extracted by mini-css-extract-plugin
export default {"Unavailable":"Unavailable_Unavailable__Jq2cn","Unavailable-description":"Unavailable_Unavailable-description__W543E","Unavailable-logo":"Unavailable_Unavailable-logo__phQ5Z"};